import React, { useContext } from "react";
import { Button } from "semantic-ui-react";
import { AnnotationContext } from "./AnnotationServiceProvider";

const EditAnnotationButton = () => {
  const { isEditing, setEditing } = useContext(AnnotationContext);
  return (
    <Button
      className="ui compact button"
      onClick={() => setEditing(!isEditing())}
    >
      {isEditing() ? "Stop Annotating" : "Start Annotating"}
    </Button>
  );
};

export default EditAnnotationButton;
